
var template = require('./index.html')
var locales = require('./locales.json')
var t = require('../translate')

module.exports = {
  template: template,
  data: data,
  components: {
    'app-logo': require('../logo')
  },
  methods: {
    slideto: require('../animation/slideto')
  }
}

function data () {
  return {
    nav: {      
      products: t(locales, 'nav.products'),
      contact: t(locales, 'nav.contact')
    },

    tagline: t(locales, 'tagline'),
    social: t(locales, 'social')
  }
}


// WEBPACK FOOTER //
// ./lib/header/index.js